// extracted by mini-css-extract-plugin
export default {"container":"docQuestion_container__9TEY5","light":"docQuestion_light__HVe-g","dark":"docQuestion_dark__u7+LH","text":"docQuestion_text__XmniT","icon":"docQuestion_icon__jEisS"};